import { render, staticRenderFns } from "./LoginErrorView.vue?vue&type=template&id=0cf236f9&scoped=true"
import script from "./LoginErrorView.vue?vue&type=script&lang=ts"
export * from "./LoginErrorView.vue?vue&type=script&lang=ts"
import style0 from "./LoginErrorView.vue?vue&type=style&index=0&id=0cf236f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf236f9",
  null
  
)

export default component.exports